import { c as _c } from "react/compiler-runtime";
import type { TagGeneralSkillLevel } from '@/common/enums';
import { LightCard } from '@/frontend/design-system/data-display/Card';
import { H2 } from '@/frontend/design-system/typography/Heading';
import { ExperienceItem } from './ExperienceItem';
type WorkExperience = {
  company: string;
  role: string;
  description: string;
  from: string;
  to?: string | null;
  skills: {
    name: string;
    imageUrl?: string;
    level: TagGeneralSkillLevel;
  }[];
};
type ExperiencesProps = {
  workExperiences: WorkExperience[];
};
export function Experience(t0) {
  const $ = _c(5);
  const {
    workExperiences
  } = t0;
  if (!workExperiences || workExperiences.length === 0) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <H2>Doświadczenie zawodowe</H2>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== workExperiences) {
    t2 = workExperiences.map(_temp);
    $[1] = workExperiences;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <LightCard className="max-w-5xl space-y-8 shadow-sm">{t1}<div className="space-y-10">{t2}</div></LightCard>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
}
function _temp(experience) {
  return <ExperienceItem key={`${experience.company}-${experience.role}`} experience={experience} />;
}